import { InjectionToken } from '@angular/core'

export const USE_ORDER_CENTRIC = new InjectionToken<boolean>(
  'USE_ORDER_CENTRIC',
  {
    providedIn: 'root',
    factory: () => false
  }
)
